module.exports = __webpack_public_path__ + "img/new_point0.bdce7168.png";